(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    /**
   * Animates a native <details> element open/closed by transitioning the
   * content wrapper's pixel height. We keep the element open during the
   * close animation so the browser doesn't yank the content out from under
   * the transition, then flip the `open` attribute at the end.
   *
   * @param {HTMLDetailsElement} details
   * @returns {void}
   */
  function initAccordion(details) {
    if (details.dataset.initialised === 'true') return;
    details.dataset.initialised = 'true';

    const summary = details.querySelector('summary');
    const content = details.querySelector('[data-js="accordion-content"]');
    if (!summary || !content) return;

    /** @type {Animation | null} */
    let currentTransition = null;

    /**
     * Cancel any in-flight transition and clean up inline styles.
     * @returns {void}
     */
    function reset() {
      content.removeAttribute('data-animating');
      content.style.height = '';
      content.style.opacity = '';
      currentTransition = null;
    }

    /**
     * @param {boolean} opening
     * @returns {void}
     */
    function animate(opening) {
      // Ensure the panel is laid out before we read/write its height.
      // For opening, this lifts the UA's "closed" hiding so the box exists.
      if (opening) details.open = true;

      // Determine start/end heights. When opening, the natural height is
      // available now (details is open), so we start from 0 and grow to it.
      // When closing, we start from the current rendered height and shrink
      // to 0 — keeping `details.open = true` until transitionend so the
      // browser doesn't yank the content out mid-animation.
      const startHeight = opening ? 0 : content.getBoundingClientRect().height;
      const targetHeight = opening ? content.scrollHeight : 0;

      content.setAttribute('data-animating', '');
      content.style.height = startHeight + 'px';
      content.style.opacity = opening ? '0' : '1';

      const onEnd = (event) => {
        if (event.propertyName !== 'height') return;
        content.removeEventListener('transitionend', onEnd);
        content.removeEventListener('transitioncancel', onEnd);
        if (!opening) details.open = false;
        reset();
      };

      content.addEventListener('transitionend', onEnd);
      content.addEventListener('transitioncancel', onEnd);
      currentTransition = onEnd;

      // Two rAFs: first frame commits the "from" state (height/opacity at
      // their starting values, immediately after `details.open` flipped on
      // for opens), second frame commits the "to" state. iOS Safari needs
      // this gap to register a transitionable starting box; a single
      // `offsetHeight` flush isn't reliable here because the box only just
      // became visible.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          content.style.height = targetHeight + 'px';
          content.style.opacity = opening ? '1' : '0';
        });
      });
    }

    summary.addEventListener('click', (event) => {
      const styles = window.getComputedStyle(summary);
      if (styles.pointerEvents === 'none' || styles.display === 'none') return;

      event.preventDefault();

      // If mid-animation, cancel and reverse.
      if (currentTransition) {
        content.style.transition = 'none';
        reset();
        // Force reflow so the next animation picks up cleanly.
        // eslint-disable-next-line no-unused-expressions
        content.offsetHeight;
        content.style.transition = '';
      }

      animate(!details.open);
    });
  }

  /**
   * Initialise every accordion currently on the page, and watch for new
   * ones (e.g. content injected by Searchspring or a quick view).
   * @returns {void}
   */
  function initAccordions(root) {
    const scope = root || document;
    const nodes = scope.querySelectorAll('[data-js="accordion"]');
    for (const node of nodes) initAccordion(node);
  }

  initAccordions();

  if (!window.__accordionObserver) {
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches && node.matches('[data-js="accordion"]')) initAccordion(node);
          initAccordions(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.__accordionObserver = observer;
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["desktop-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    if (customElements.get('mega-menu')) return;

    /* ── Logic timers (not animation durations) ─────────────── */
    const INTENT_DELAY = 80; /* hover-intent debounce before opening   */
    const GRACE_DELAY = 120; /* diagonal-travel grace before closing   */
    const DECODE_TIMEOUT = 300; /* max wait for image decode before reveal */
    const DESKTOP_MIN_WIDTH = 1200;
    const SURFACE = 'mega-menu';

    /**
     * Desktop mega menu. Owns its interaction FSM and panel markup;
     * the header forwards nav pointer/focus events via the public
     * methods below. Opening/closing routes through the surface manager
     * for exclusivity with the search and mobile surfaces.
     */
    class MegaMenu extends HTMLElement {
      /** @type {'closed'|'pending'|'open'|'grace'} */
      #state = 'closed';
      /** @type {string|null} */
      #currentMenuId = null;
      /** @type {string|null} */
      #pendingMenuId = null;
      #intentTimer = null;
      #graceTimer = null;
      #scrollLocked = false;
      #unregister = null;
      #popoverSupported = false;
      #nav = null;
      #navLinks = [];
      #parents = [];

      connectedCallback() {
        if (this.dataset.initialised === 'true') return;

        const tu = window.themeUtils;
        if (!tu || !tu.surfaces) return;
        this.#tu = tu;

        this.#popoverSupported =
          typeof this.showPopover === 'function' &&
          Object.prototype.hasOwnProperty.call(HTMLElement.prototype, 'popover');

        this.#nav = document.querySelector('[data-header-menu-desktop]');
        this.#navLinks = this.#nav ? Array.from(this.#nav.querySelectorAll('a[data-menu-id]')) : [];
        this.#parents = Array.from(this.querySelectorAll('.desktop-menu-panel__parent'));

        /* Defensive a11y wiring so the element is usable before the
           header markup (Phase 2) renders these attributes itself. */
        this.#navLinks.forEach((link) => {
          if (!link.hasAttribute('aria-controls')) link.setAttribute('aria-controls', 'desktop-menu-panel');
          if (!link.hasAttribute('aria-expanded')) link.setAttribute('aria-expanded', 'false');
        });

        this.#reposition = tu.throttle(() => {
          if (this.#state === 'open' || this.#state === 'grace') this.#updatePosition();
        });

        this.#unregister = tu.surfaces.register(SURFACE, {
          open: (detail) => this.#applyOpen(detail),
          close: () => this.#applyClose(),
          exclusive: true,
        });

        tu.on('header:sticky-change', this.#reposition);
        window.addEventListener('scroll', this.#reposition, { passive: true });
        document.addEventListener('keydown', this.#onKeydown);
        this.addEventListener('pointerenter', this.#onPanelEnter);
        this.addEventListener('pointerleave', this.#onPanelLeave);
        this.addEventListener('focusout', this.#onPanelFocusOut);

        this.dataset.initialised = 'true';
      }

      disconnectedCallback() {
        this.#clearIntent();
        this.#clearGrace();
        this.#releaseHost();
        if (this.#unregister) this.#unregister();
        if (this.#tu) {
          this.#tu.off('header:sticky-change', this.#reposition);
        }
        window.removeEventListener('scroll', this.#reposition);
        document.removeEventListener('keydown', this.#onKeydown);
        this.removeEventListener('pointerenter', this.#onPanelEnter);
        this.removeEventListener('pointerleave', this.#onPanelLeave);
        this.removeEventListener('focusout', this.#onPanelFocusOut);
      }

      /* ── Public method contract (called by the header) ──────── */

      /**
       * Request the panel for `menuId`. With `intent` (pointer), applies
       * the 80ms hover-intent delay when currently closed and switches
       * instantly when already open. Without `intent` (keyboard) or under
       * reduced motion, opens/switches immediately. Cancels any pending
       * grace-close.
       * @param {string|number} menuId - Parent index (matches data-menu-id)
       * @param {Object} [options] - { intent?: boolean }
       * @returns {void}
       */
      show(menuId, options) {
        if (!this.#matchesBreakpoint()) return;
        const id = String(menuId);
        const intent = !options || options.intent !== false;
        this.#clearGrace();
        if (this.#state === 'grace') this.#state = 'open';

        if (this.#state === 'open') {
          if (this.#currentMenuId !== id) this.#activatePanel(id);
          return;
        }

        if (!intent || this.#reducedMotion()) {
          this.#openWith(id);
          return;
        }

        this.#pendingMenuId = id;
        this.#state = 'pending';
        this.#preloadImages(id);
        this.#clearIntent();
        this.#intentTimer = setTimeout(() => {
          this.#intentTimer = null;
          this.#openWith(this.#pendingMenuId);
        }, INTENT_DELAY);
      }

      /**
       * Begin closing. While still in the pre-open intent window this
       * cancels immediately; while open it starts the 120ms grace timer
       * (cancelled by a subsequent show/cancelHide). Under reduced motion
       * it closes instantly.
       * @returns {void}
       */
      scheduleHide() {
        if (this.#state === 'pending') {
          this.#clearIntent();
          this.#state = 'closed';
          this.#pendingMenuId = null;
          return;
        }
        if (this.#state !== 'open' && this.#state !== 'grace') return;
        if (this.#reducedMotion()) {
          this.#commitClose();
          return;
        }
        this.#state = 'grace';
        this.#clearGrace();
        this.#graceTimer = setTimeout(() => {
          this.#graceTimer = null;
          this.#commitClose();
        }, GRACE_DELAY);
      }

      /**
       * Cancel a pending grace-close (pointer/focus re-entered a safe
       * zone) and return to the open state.
       * @returns {void}
       */
      cancelHide() {
        this.#clearGrace();
        if (this.#state === 'grace') this.#state = 'open';
      }

      /**
       * Close immediately, bypassing the grace timer (Escape / focus
       * leaving the menu).
       * @param {Object} [options] - { refocus?: boolean } — refocus the active nav link
       * @returns {void}
       */
      closeNow(options) {
        const refocusId = this.#currentMenuId;
        this.#clearIntent();
        this.#clearGrace();
        this.#commitClose();
        if (options && options.refocus && refocusId != null) {
          const link = this.#navLinks.find((l) => l.dataset.menuId === String(refocusId));
          if (link) link.focus();
        }
      }

      /* ── Surface-manager handlers (called only by the manager) ─ */

      /**
       * Manager-invoked open. Shows the host and activates the requested
       * panel. Never call directly — go through the manager via #openWith.
       * @param {Object} detail - { menuId?: string|number }
       * @returns {void}
       */
      #applyOpen(detail) {
        const id = String(detail && detail.menuId != null ? detail.menuId : this.#pendingMenuId);
        this.#showHost();
        this.#state = 'open';
        this.#activatePanel(id);
      }

      /**
       * Manager-invoked close. Tears down the host and resets the FSM.
       * @returns {void}
       */
      #applyClose() {
        this.#clearIntent();
        this.#clearGrace();
        this.#releaseHost();
        this.#deactivateAll();
        this.#currentMenuId = null;
        this.#pendingMenuId = null;
        this.#state = 'closed';
      }

      /* ── Open / close routing through the surface manager ───── */

      /**
       * Open, or switch when already open. Routes the initial open through
       * the surface manager (exclusivity); switches panels internally.
       * @param {string} id
       * @returns {void}
       */
      #openWith(id) {
        this.#clearIntent();
        if (this.#state === 'open') {
          if (this.#currentMenuId !== id) this.#activatePanel(id);
          return;
        }
        this.#pendingMenuId = id;
        const surfaces = this.#tu && this.#tu.surfaces;
        if (surfaces) {
          surfaces.open(SURFACE, { menuId: id });
        } else {
          this.#applyOpen({ menuId: id });
        }
      }

      /** @returns {void} */
      #commitClose() {
        const surfaces = this.#tu && this.#tu.surfaces;
        if (surfaces && surfaces.current() === SURFACE) {
          surfaces.close(SURFACE);
        } else {
          this.#applyClose();
        }
      }

      /* ── Host (popover) visibility + position ───────────────── */

      /** @returns {void} */
      #showHost() {
        this.#updatePosition();
        if (this.#popoverSupported && !this.matches(':popover-open')) {
          try {
            this.showPopover();
          } catch (err) {
            /* swallow — fall through to the data-state fallback path */
          }
        }
        this.dataset.state = 'open';
        if (!this.#scrollLocked && this.#tu) {
          this.#tu.lockScroll(SURFACE);
          this.#scrollLocked = true;
        }
      }

      /** @returns {void} */
      #releaseHost() {
        if (this.#popoverSupported && this.matches(':popover-open')) {
          try {
            this.hidePopover();
          } catch (err) {
            /* already hidden */
          }
        }
        delete this.dataset.state;
        if (this.#scrollLocked && this.#tu) {
          this.#tu.unlockScroll(SURFACE);
          this.#scrollLocked = false;
        }
      }

      /** @returns {void} */
      #updatePosition() {
        if (!this.#header) this.#header = document.querySelector('.header');
        if (!this.#header) return;
        const bottom = this.#header.getBoundingClientRect().bottom;
        this.style.setProperty('--desktop-menu-top', bottom + 'px');
      }

      /* ── Panel activation ───────────────────────────────────── */

      /**
       * Switch the visible panel to `id` (instant; no host transition).
       * @param {string} id
       * @returns {void}
       */
      #activatePanel(id) {
        const menuId = String(id);
        this.#deactivateAll();
        const target = this.querySelector('.desktop-menu-panel__parent[data-menu-id="' + menuId + '"]');
        if (!target) {
          this.#currentMenuId = null;
          return;
        }
        this.#hydrate(target);
        target.setAttribute('data-active', '');
        this.#navLinks.forEach((link) => {
          if (link.dataset.menuId === menuId) {
            link.setAttribute('data-active', '');
            link.setAttribute('aria-expanded', 'true');
          }
        });
        this.#currentMenuId = menuId;
        this.#revealImages(target, menuId);
      }

      /** @returns {void} */
      #deactivateAll() {
        this.#parents.forEach((parent) => {
          parent.removeAttribute('data-active');
          const images = parent.querySelector('.desktop-menu-panel__images');
          if (images) images.removeAttribute('data-ready');
        });
        this.#navLinks.forEach((link) => {
          link.removeAttribute('data-active');
          link.setAttribute('aria-expanded', 'false');
        });
      }

      /* ── Image hydration + decode-before-reveal ─────────────── */

      /**
       * Clone the promo-image template into the DOM (once) so lazy images
       * start loading. Called at intent time for a head start.
       * @param {string} id
       * @returns {void}
       */
      #preloadImages(id) {
        const target = this.querySelector('.desktop-menu-panel__parent[data-menu-id="' + String(id) + '"]');
        if (target) this.#hydrate(target);
      }

      /**
       * Replace a parent's `<template>` with its live image markup.
       * @param {HTMLElement} target
       * @returns {void}
       */
      #hydrate(target) {
        const template = target.querySelector('template[data-images-template]');
        if (!template) return;
        template.parentNode.insertBefore(template.content.cloneNode(true), template);
        template.remove();
      }

      /**
       * Reveal a parent's images once decoded, racing a timeout so a slow
       * decode never blocks the panel. Bails if the panel changed meanwhile.
       * @param {HTMLElement} target
       * @param {string} menuId
       * @returns {Promise<void>}
       */
      async #revealImages(target, menuId) {
        const container = target.querySelector('.desktop-menu-panel__images');
        if (!container) return;
        const images = Array.from(container.querySelectorAll('img'));
        if (images.length === 0) {
          container.setAttribute('data-ready', '');
          return;
        }
        await Promise.race([
          Promise.allSettled(images.map((img) => (img.decode ? img.decode() : Promise.resolve()))),
          new Promise((resolve) => setTimeout(resolve, DECODE_TIMEOUT)),
        ]);
        if (this.#currentMenuId !== menuId) return;
        container.setAttribute('data-ready', '');
      }

      /* ── Self-owned interaction handlers (panel + keyboard) ─── */

      #onPanelEnter = () => {
        this.cancelHide();
      };

      #onPanelLeave = () => {
        this.scheduleHide();
      };

      #onPanelFocusOut = (event) => {
        const next = event.relatedTarget;
        if (next && (this.contains(next) || (this.#nav && this.#nav.contains(next)))) return;
        this.closeNow();
      };

      #onKeydown = (event) => {
        if (event.key !== 'Escape') return;
        if (this.#state === 'closed') return;
        event.preventDefault();
        this.closeNow({ refocus: this.#state === 'open' || this.#state === 'grace' });
      };

      /* ── Helpers ────────────────────────────────────────────── */

      /** @returns {boolean} */
      #matchesBreakpoint() {
        return window.matchMedia('(min-width: ' + DESKTOP_MIN_WIDTH + 'px)').matches;
      }

      /** @returns {boolean} */
      #reducedMotion() {
        return !!(this.#tu && this.#tu.prefersReducedMotion);
      }

      /** @returns {void} */
      #clearIntent() {
        if (this.#intentTimer !== null) {
          clearTimeout(this.#intentTimer);
          this.#intentTimer = null;
        }
      }

      /** @returns {void} */
      #clearGrace() {
        if (this.#graceTimer !== null) {
          clearTimeout(this.#graceTimer);
          this.#graceTimer = null;
        }
      }

      #tu = null;
      #header = null;
      #reposition = null;
    }

    customElements.define('mega-menu', MegaMenu);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-card-balance"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';

    // The Storefront API is served from the domain root, never under a market prefix.
    const GIFT_CARD_BALANCE_ENDPOINT = '/api/2026-07/graphql.json';

    const GIFT_CARD_BALANCE_CART = `mutation GiftCardBalance($input: CartInput!) {
      cartCreate(input: $input) {
        cart { appliedGiftCards { lastCharacters balance { amount currencyCode } } }
        userErrors { code message }
      }
    }`;

    const GIFT_CARD_BALANCE_CHEAPEST_PRODUCTS = `{
      products(first: 10, sortKey: PRICE, query: "available_for_sale:true") {
        nodes { isGiftCard variants(first: 5) { nodes { id availableForSale } } }
      }
    }`;

    /**
     * Run a Storefront API query with the theme's public token.
     * @param {string} query - GraphQL document.
     * @param {Object} [variables] - GraphQL variables.
     * @returns {Promise<Object>} The response's data.
     */
    async function storefrontQuery(query, variables) {
      const token = window.themeSettings && window.themeSettings.storefrontApiToken;
      if (!token) throw new Error('Missing Storefront API token');
      const response = await fetch(GIFT_CARD_BALANCE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
        body: JSON.stringify({ query, variables }),
      });
      if (!response.ok) throw new Error(`Storefront API ${response.status}`);
      const payload = await response.json();
      if (payload.errors) throw new Error('Storefront API errors');
      return payload.data;
    }

    /**
     * Read the applied gift card from a cartCreate response.
     * @param {Object} data - cartCreate response data.
     * @returns {Object|null} The applied gift card, or null when the code didn't apply.
     */
    function appliedGiftCard(data) {
      const cards = data && data.cartCreate && data.cartCreate.cart ? data.cartCreate.cart.appliedGiftCards : [];
      return cards[0] || null;
    }

    /**
     * Find the cheapest variant that can go in a cart, for stores that only apply gift cards to a cart with a line.
     * @returns {Promise<string|null>} A variant id, or null when nothing is for sale.
     */
    async function cheapestVariantId() {
      const data = await storefrontQuery(GIFT_CARD_BALANCE_CHEAPEST_PRODUCTS);
      const variant = data.products.nodes
        .filter((product) => !product.isGiftCard)
        .flatMap((product) => product.variants.nodes)
        .find((item) => item.availableForSale);
      return variant ? variant.id : null;
    }

    /**
     * Look a gift card code up by applying it to a new cart: first an empty one, then one with a single line.
     * @param {string} code - Normalised gift card code.
     * @returns {Promise<Object|null>} The gift card's lastCharacters and balance, or null when not found.
     */
    async function lookUpGiftCard(code) {
      const fromEmptyCart = appliedGiftCard(await storefrontQuery(GIFT_CARD_BALANCE_CART, { input: { giftCardCodes: [code] } }));
      if (fromEmptyCart) return fromEmptyCart;
      const variantId = await cheapestVariantId();
      if (!variantId) return null;
      return appliedGiftCard(
        await storefrontQuery(GIFT_CARD_BALANCE_CART, {
          input: { giftCardCodes: [code], lines: [{ merchandiseId: variantId, quantity: 1 }] },
        })
      );
    }

    /**
     * Format a Storefront API money object for the shopper's locale.
     * @param {Object} money - Money to format.
     * @param {string} money.amount - Decimal amount.
     * @param {string} money.currencyCode - ISO currency code.
     * @param {string} locale - BCP 47 locale, e.g. en-AU.
     * @returns {string} The formatted amount.
     */
    function formatGiftCardMoney(money, locale) {
      const options = { style: 'currency', currency: money.currencyCode };
      try {
        return new Intl.NumberFormat(locale, options).format(Number(money.amount));
      } catch {
        return new Intl.NumberFormat('en', options).format(Number(money.amount));
      }
    }

    /**
     * Whether the shopper asked for reduced motion.
     * @returns {boolean} True when motion should be skipped.
     */
    function prefersReducedMotion() {
      if (window.themeUtils && typeof window.themeUtils.prefersReducedMotion === 'boolean') {
        return window.themeUtils.prefersReducedMotion;
      }
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /**
     * Tilt the card towards the pointer, lift it while hovered and spin it on click.
     * @param {HTMLElement} root - The gift-card-balance root element.
     * @returns {void}
     */
    function initialiseGiftCardMotion(root) {
      const preview = root.querySelector('[data-js="gift-card-balance-preview"]');
      const stage = root.querySelector('[data-js="gift-card-balance-stage"]');
      const card = root.querySelector('[data-js="gift-card-balance-card"]');

      card.addEventListener('animationend', () => {
        card.dataset.spinning = 'false';
      });

      card.addEventListener('click', () => {
        if (prefersReducedMotion()) return;
        card.dataset.spinning = 'false';
        requestAnimationFrame(() => {
          card.dataset.spinning = 'true';
        });
      });

      preview.addEventListener('pointerenter', () => {
        if (!prefersReducedMotion()) stage.dataset.active = 'true';
      });

      preview.addEventListener('pointermove', (event) => {
        if (prefersReducedMotion()) return;
        const box = stage.getBoundingClientRect();
        const x = Math.min(Math.max((event.clientX - box.left) / box.width, -0.25), 1.25);
        const y = Math.min(Math.max((event.clientY - box.top) / box.height, -0.25), 1.25);
        stage.dataset.active = 'true';
        stage.dataset.tilting = 'true';
        stage.style.setProperty('--tilt-y', `${((x - 0.5) * 8).toFixed(2)}deg`);
        stage.style.setProperty('--tilt-x', `${((0.5 - y) * 6).toFixed(2)}deg`);
        stage.style.setProperty('--shine-x', `${(x * 100).toFixed(1)}%`);
        stage.style.setProperty('--shadow-x', `${((0.5 - x) * 8).toFixed(1)}px`);
        stage.style.setProperty('--shine', '1');
      });

      /**
       * Return the card to rest. The shine keeps its last position so it fades out where the pointer left it.
       * @returns {void}
       */
      function settle() {
        stage.dataset.active = 'false';
        stage.dataset.tilting = 'false';
        ['--tilt-x', '--tilt-y', '--shadow-x', '--shine'].forEach((property) => {
          stage.style.removeProperty(property);
        });
      }

      preview.addEventListener('pointerleave', settle);
      preview.addEventListener('pointercancel', settle);
      preview.addEventListener('pointerup', (event) => {
        if (event.pointerType !== 'mouse') settle();
      });
    }

    /**
     * Initialise a gift card balance checker.
     * @param {HTMLElement} root - The gift-card-balance root element.
     * @returns {void}
     */
    function initialiseGiftCardBalance(root) {
      root.dataset.initialised = 'true';
      initialiseGiftCardMotion(root);

      const one = (hook) => root.querySelector(`[data-js="gift-card-balance-${hook}"]`);
      const locale = root.dataset.locale;
      const form = one('form');
      const input = one('input');
      const error = one('error');
      const submit = one('submit');
      const result = one('result');
      const withLastCharacters = (text, lastCharacters) => text.replace('{last_characters}', lastCharacters);

      /**
       * Show or clear the form error.
       * @param {string} text - Error message, or an empty string to clear it.
       * @returns {void}
       */
      function setError(text) {
        error.hidden = !text;
        error.textContent = text;
        input.setAttribute('aria-invalid', text ? 'true' : 'false');
      }

      /**
       * Toggle the submit button's loading state.
       * @param {boolean} busy - Whether a lookup is running.
       * @returns {void}
       */
      function setBusy(busy) {
        submit.disabled = busy;
        if (busy) {
          submit.dataset.state = 'loading';
        } else {
          delete submit.dataset.state;
        }
        submit.textContent = busy ? root.dataset.labelChecking : root.dataset.labelSubmit;
      }

      /**
       * Show a found card's balance in the panel and on the card.
       * @param {Object} giftCard - The found card.
       * @param {string} giftCard.lastCharacters - Last characters of the code.
       * @param {Object} giftCard.balance - Money left on the card.
       * @returns {void}
       */
      function showResult(giftCard) {
        const amount = formatGiftCardMoney(giftCard.balance, locale);
        const empty = Number(giftCard.balance.amount) <= 0;
        one('amount').textContent = amount;
        one('detail').textContent = withLastCharacters(empty ? root.dataset.labelFullyUsed : root.dataset.labelBalanceLeft, giftCard.lastCharacters);
        one('note').textContent = empty ? root.dataset.labelNoBalance : root.dataset.labelUseAtCheckout;
        one('card-amount').textContent = amount;
        one('card-ending').textContent = withLastCharacters(root.dataset.labelCardEnding, giftCard.lastCharacters);
        root.dataset.state = 'found';
        result.hidden = false;
      }

      input.addEventListener('input', () => {
        if (input.getAttribute('aria-invalid') === 'true') setError('');
      });

      one('again').addEventListener('click', () => {
        root.dataset.state = 'idle';
        result.hidden = true;
        setError('');
        input.value = '';
        input.focus();
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const code = input.value.replace(/[\s-]/g, '').toUpperCase();
        result.hidden = true;
        root.dataset.state = 'idle';

        if (!/^[A-Z0-9]{8,20}$/.test(code)) {
          setError(root.dataset.labelInvalidCode);
          input.focus();
          return;
        }

        setError('');
        setBusy(true);
        try {
          const giftCard = await lookUpGiftCard(code);
          if (giftCard) {
            showResult(giftCard);
          } else {
            setError(root.dataset.labelNotFound);
            input.focus();
          }
        } catch {
          setError(root.dataset.labelLookupFailed);
        } finally {
          setBusy(false);
        }
      });
    }

    document
      .querySelectorAll('[data-js="gift-card-balance"]:not([data-initialised="true"])')
      .forEach(initialiseGiftCardBalance);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["market-suggest"] && !Shopify.designMode) return;
  try {
    /**
   * Initialise the market-suggest banner: resolve the visitor's detected
   * country (session cache, ?suggest_country override, or a deferred
   * fetch), and when another store serves it, offer the switch.
   * @param {HTMLElement} root - The banner root element.
   * @returns {void}
   */
  function initialiseMarketSuggest(root) {
    root.dataset.initialised = 'true';

    const configEl = document.querySelector('[data-js="market-suggest-config"]');
    let config = null;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (error) {
      return;
    }

    const hosts = Object.keys(config.storeLabels);
    const params = new URLSearchParams(window.location.search);
    const override = (params.get('suggest_country') || '').toUpperCase();
    if (hosts.indexOf(window.location.host) === -1 && !/^[A-Z]{2}$/.test(override)) return;
    if (document.cookie.indexOf('pm-market-pref=') !== -1) return;
    if (document.documentElement.dataset.appView === 'true') return;

    const messageEl = root.querySelector('[data-js="market-suggest-message"]');
    const switchEl = root.querySelector('[data-js="market-suggest-switch"]');

    const HIDE_MS = 200;

    /**
     * Session-storage access that tolerates storage being unavailable.
     * @param {string} key - Storage key.
     * @param {string} [value] - When present, the value to write.
     * @returns {string|null} The stored value for reads, null otherwise.
     */
    function session(key, value) {
      try {
        if (value === undefined) return window.sessionStorage.getItem(key);
        window.sessionStorage.setItem(key, value);
      } catch (error) {
        return null;
      }
      return null;
    }

    /**
     * Persist a market preference for 180 days as a host-only cookie.
     * @param {string} value - `stay` or a storefront host.
     * @returns {void}
     */
    function writePref(value) {
      document.cookie =
        'pm-market-pref=' + encodeURIComponent(value) + '; path=/; max-age=15552000; secure; samesite=lax';
    }

    /**
     * Human-readable country name for an ISO code, falling back to the
     * code itself when Intl.DisplayNames is unavailable.
     * @param {string} handle - ISO 3166-1 alpha-2 country code.
     * @returns {string} Display name.
     */
    function countryName(handle) {
      if (typeof Intl === 'undefined' || typeof Intl.DisplayNames !== 'function') return handle;
      try {
        const language = document.documentElement.lang || 'en';
        return new Intl.DisplayNames([language], { type: 'region' }).of(handle) || handle;
      } catch (error) {
        return handle;
      }
    }

    /**
     * Hide the banner, letting the exit transition finish first.
     * @returns {void}
     */
    function hide() {
      root.dataset.visible = 'false';
      window.setTimeout(() => {
        root.hidden = true;
      }, HIDE_MS);
    }

    /**
     * The current query string for a link to another store, minus Yotpo's
     * referral parameters: a referral invite is only redeemable on the store
     * that issued it, and carrying them across would fire the other store's
     * referral pop-up against a code its loyalty account cannot honour.
     * @returns {string} The query string with its leading `?`, or an empty string.
     */
    function crossStoreSearch() {
      const query = new URLSearchParams(window.location.search);
      query.delete('sref_id');
      query.delete('cref_id');
      const serialised = query.toString();
      return serialised ? '?' + serialised : '';
    }

    /**
     * Reveal the banner offering the store that serves the detection.
     * Defers while Shopify's cookie banner is awaiting a consent choice.
     * @param {string} handle - Detected ISO country code.
     * @param {string} target - Storefront host serving that country.
     * @returns {void}
     */
    function reveal(handle, target) {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.shouldShowBanner === 'function' && privacy.shouldShowBanner()) return;
      messageEl.textContent = root.dataset.textMessage.replace('%%COUNTRY%%', countryName(handle));
      switchEl.textContent = root.dataset.textSwitchCta.replace('%%STORE%%', config.storeLabels[target] || target);
      switchEl.href = 'https://' + target + window.location.pathname + crossStoreSearch() + window.location.hash;
      root.hidden = false;
      window.requestAnimationFrame(() => {
        root.dataset.visible = 'true';
      });
    }

    /**
     * Resolve a detection to a suggestion and show it when relevant.
     * @param {string} handle - Detected ISO country code.
     * @returns {void}
     */
    function applyDetection(handle) {
      session('market-suggest-detected', handle);
      const target = config.map[handle] || config.defaultHost;
      if (target === window.location.host) return;
      reveal(handle, target);
    }

    /**
     * Fetch the visitor's detected country from Shopify.
     * @returns {Promise<void>} Resolves after detection is applied or abandoned.
     */
    async function detect() {
      const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const controller = new AbortController();
      const timer = window.setTimeout(() => {
        controller.abort();
      }, 4000);
      try {
        const response = await window.fetch(rootPath + 'browsing_context_suggestions.json?country%5Benabled%5D=true', {
          signal: controller.signal,
        });
        if (!response.ok) return;
        const data = await response.json();
        const handle =
          data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (typeof handle === 'string' && /^[A-Z]{2}$/.test(handle.toUpperCase())) applyDetection(handle.toUpperCase());
      } catch (error) {
        /* Detection is best-effort: on failure the visitor simply browses on. */
      } finally {
        window.clearTimeout(timer);
      }
    }

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-js="market-suggest-switch"]')) {
        writePref(new URL(switchEl.href).host);
        // An explicit store choice supersedes the referral-landing exemption
        // market-suggest-init holds for this tab session.
        session('market-suggest-referral', '');
        return;
      }
      if (event.target.closest('[data-js="market-suggest-stay"]')) {
        writePref('stay');
        hide();
        return;
      }
      if (event.target.closest('[data-js="market-suggest-dismiss"]')) {
        session('market-suggest-dismissed', '1');
        hide();
      }
    });

    if (session('market-suggest-dismissed')) return;

    if (/^[A-Z]{2}$/.test(override)) {
      applyDetection(override);
      return;
    }
    const cached = session('market-suggest-detected');
    if (cached) {
      applyDetection(cached);
      return;
    }
    const idle = window.requestIdleCallback || ((fn) => window.setTimeout(fn, 1500));
    idle(() => {
      const late = session('market-suggest-detected');
      if (late) {
        applyDetection(late);
        return;
      }
      detect();
    });
  }

  document
    .querySelectorAll('[data-js="market-suggest"]:not([data-initialised="true"])')
    .forEach(initialiseMarketSuggest);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meta-tags"] && !Shopify.designMode) return;
  try {
    /**
   * Build a schema.org Review node from one review in the Yotpo snapshot.
   * @param {object} review - A review entry from the preloaded_reviews payload.
   * @returns {object | null} Null when the review lacks the required fields
   *   or a 1-5 score — an out-of-range ratingValue invalidates the node.
   */
  function buildReviewNode(review) {
    const user = review && review.user;
    const score = review ? Number(review.score) : NaN;
    if (!review || !review.content || !user || !user.displayName) return null;
    if (!(score >= 1 && score <= 5)) return null;
    const node = {
      '@type': 'Review',
      author: { '@type': 'Person', name: String(user.displayName) },
      reviewBody: String(review.content),
      reviewRating: {
        '@type': 'Rating',
        ratingValue: score,
        bestRating: 5,
        worstRating: 1,
      },
    };
    if (review.title) node.name = String(review.title);
    if (review.createdAt) node.datePublished = String(review.createdAt).slice(0, 10);
    return node;
  }

  /**
   * Inject the individual-review JSON-LD node from the inert Yotpo reviews
   * payload. The `@id` matches the server-rendered aggregate node so search
   * engines merge both into the one product entity; the aggregate stays
   * server-side because non-rendering crawlers never see this script's output.
   * @returns {void}
   */
  function injectYotpoReviewSchema() {
    const source = document.querySelector('script[data-js="yotpo-reviews-data"]');
    if (!source || !source.dataset.entityId) return;

    let payload = null;
    try {
      payload = JSON.parse(source.textContent);
    } catch (err) {
      return;
    }

    const reviews = (payload && Array.isArray(payload.reviews) && payload.reviews) || [];
    const nodes = reviews.slice(0, 5).map(buildReviewNode).filter(Boolean);
    if (nodes.length === 0) return;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Product',
      '@id': source.dataset.entityId,
      review: nodes,
    });
    document.head.appendChild(script);
  }

  injectYotpoReviewSchema();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-menu"] && !Shopify.designMode) return;
  try {
    /* global DrawerDialog */
  (function () {
    'use strict';

    if (!window.DrawerDialog || window.customElements.get('mobile-menu-drawer')) return;

    const DECODE_GUARD_MS = 300; /* image decode-before-reveal guard, not an animation */
    const SWIPE_EDGE_PX = 24; /* leave the iOS back-swipe gutter alone */
    const SWIPE_CLAIM_PX = 8; /* horizontal intent threshold */
    const SWIPE_CLOSE_FRACTION = 0.35; /* >35vw dismisses */
    const SWIPE_CLOSE_VELOCITY = 0.5; /* px/ms rightward flick dismisses */
    const SWIPE_VELOCITY_WINDOW_MS = 80;
    const SWIPE_DAMPING = 0.9;
    const SWIPE_MIN_OPACITY = 0.6;

    /**
     * Mobile menu drawer custom element. Extends the shared DrawerDialog
     * base (open/close/modality/focus/scroll-lock/registration provided).
     */
    class MobileMenuDrawer extends window.DrawerDialog {
      /** @returns {string} the surface id this drawer registers as. */
      get surfaceName() {
        return 'mobile-menu';
      }

      /** @returns {boolean} run a View Transition morph on open (<768px). */
      get usesMorph() {
        return true;
      }

      /** @returns {boolean} emit mobile-menu:toggle so peers (minicart) sync. */
      get isMobileMenu() {
        return true;
      }

      /** Wire component behaviour once the base has registered the surface. */
      connectedCallback() {
        super.connectedCallback();
        if (this._wired) return;
        this._wired = true;

        this.nav = this.querySelector('[data-mobile-menu-nav]');
        this.searchInput = this.querySelector('[data-mobile-menu-search]');
        this._promosHydrated = false;
        this._settleAnim = null;

        this.#wireDelegatedClicks();
        this.#wireSearchHandoff();
        this.#initGesture();
      }

      /* ── Open / close hooks (called by the base) ─────────────────── */

      /**
       * Reset navigation + accordions, then hydrate promos on first open.
       * @param {Object} [detail] - unused open payload.
       * @returns {Promise<void>}
       */
      async onOpen() {
        this.#clearGestureStyles();
        this.#resetPanels();
        this.#resetAccordions();
        await this.#hydratePromos();
      }

      /** Teardown: collapse panels/accordions so the next open replays. */
      onClose() {
        if (this._settleAnim) {
          this._settleAnim.cancel();
          this._settleAnim = null;
        }
        this.#clearGestureStyles();
        this.#resetAccordions();
        if (this.nav) {
          this.nav.querySelectorAll('.mobile-menu__panel').forEach((panel) => {
            panel.removeAttribute('data-active');
            panel.setAttribute('inert', '');
          });
        }
      }

      /* ── Panel navigation ────────────────────────────────────────── */

      /**
       * Slide to a panel. Single source of truth is the nav's data-panel /
       * data-direction; CSS resolves the motion, JS only flips attributes.
       * @param {string} id - target panel id ('root' or an index).
       * @param {'forward'|'back'} direction
       */
      #navigateTo(id, direction) {
        if (!this.nav) return;
        const target = this.nav.querySelector('[data-mobile-menu-panel="' + id + '"]');
        const current = this.nav.querySelector('.mobile-menu__panel[data-active]');
        if (!target || target === current) return;

        this.nav.dataset.direction = direction;
        if (current) {
          current.removeAttribute('data-active');
          current.setAttribute('inert', '');
        }
        target.setAttribute('inert', '');
        target.scrollTop = 0;
        target.removeAttribute('inert');
        target.setAttribute('data-active', '');
        this.nav.dataset.panel = id;
      }

      /** Reset panels to the root view (used on every open). */
      #resetPanels() {
        if (!this.nav) return;
        this.nav.dataset.panel = 'root';
        this.nav.dataset.direction = 'forward';
        this.nav.querySelectorAll('.mobile-menu__panel').forEach((panel) => {
          const isRoot = panel.getAttribute('data-mobile-menu-panel') === 'root';
          if (isRoot) {
            panel.scrollTop = 0;
            panel.removeAttribute('inert');
            panel.setAttribute('data-active', '');
          } else {
            panel.removeAttribute('data-active');
            panel.setAttribute('inert', '');
          }
        });
      }

      /* ── Accordions ──────────────────────────────────────────────── */

      /**
       * Toggle an accordion. aria-expanded is the only state; CSS `:has()`
       * drives the grid expand + icon swap.
       * @param {HTMLElement} trigger
       */
      #toggleAccordion(trigger) {
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      }

      /** Collapse every accordion (on open + close). */
      #resetAccordions() {
        this.querySelectorAll('[data-accordion-trigger][aria-expanded="true"]').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });
      }

      /* ── Delegated interactions ──────────────────────────────────── */

      /** One delegated click for close, panel nav (open/back) and accordions. */
      #wireDelegatedClicks() {
        this.dialog.addEventListener('click', (event) => {
          if (event.target.closest('[data-mobile-menu-close]')) {
            window.themeUtils.surfaces.close('mobile-menu');
            return;
          }
          const openBtn = event.target.closest('[data-menu-open]');
          if (openBtn) {
            this.#navigateTo(openBtn.dataset.menuOpen, 'forward');
            return;
          }
          const backBtn = event.target.closest('[data-menu-back]');
          if (backBtn) {
            this.#navigateTo(backBtn.dataset.menuBack, 'back');
            return;
          }
          const accordion = event.target.closest('[data-accordion-trigger]');
          if (accordion) {
            this.#toggleAccordion(accordion);
          }
        });
      }

      /**
       * Hand off to the mobile search drawer on deliberate interaction.
       * Pointer/tap and Enter/Space activate it; a bare focus must not, or a
       * keyboard user tabbing through the menu is teleported out the moment
       * they reach this field and can never reach the nav links below it.
       */
      #wireSearchHandoff() {
        if (!this.searchInput) return;
        const handoff = () => {
          window.themeUtils.surfaces.replace('mobile-menu', 'mobile-search', {
            prefillQuery: this.searchInput.value,
          });
        };
        this.searchInput.addEventListener('pointerdown', (event) => {
          event.preventDefault();
          handoff();
        });
        this.searchInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handoff();
          }
        });
      }

      /* ── Promo image hydration ───────────────────────────────────── */

      /**
       * Clone the promo `<template>` on first open, decode-race images, then
       * reveal via `data-ready`.
       * @returns {Promise<void>}
       */
      async #hydratePromos() {
        if (this._promosHydrated) return;
        this._promosHydrated = true;
        const template = this.querySelector('template[data-mobile-menu-promos-template]');
        if (!template) return;
        const container = template.parentNode;
        container.appendChild(template.content.cloneNode(true));
        template.remove();

        const images = Array.from(container.querySelectorAll('img'));
        const guard = new Promise((resolve) => setTimeout(resolve, DECODE_GUARD_MS));
        await Promise.race([
          Promise.allSettled(images.map((img) => (img.decode ? img.decode() : Promise.resolve()))),
          guard,
        ]);
        container.dataset.ready = 'true';
      }

      /* ── Swipe-to-close gesture (the one place JS writes styles) ──── */

      /** Arm the finger-tracking right-swipe dismiss on the nav area. */
      #initGesture() {
        if (!this.nav) return;
        const nav = this.nav;

        let pointerId = null;
        let claimed = false;
        let originX = 0;
        let startY = 0;
        let dx = 0;
        let dy = 0;
        let samples = [];

        const write = window.themeUtils.throttle(() => {
          const x = Math.max(0, dx * SWIPE_DAMPING);
          const progress = Math.min(1, x / (window.innerWidth || 1));
          this.dialog.style.transform = 'translateX(' + x + 'px)';
          this.dialog.style.opacity = String(1 - progress * (1 - SWIPE_MIN_OPACITY));
        });

        const resetPointer = () => {
          pointerId = null;
          claimed = false;
          dx = 0;
          dy = 0;
          samples = [];
        };

        const onDown = (event) => {
          if (window.themeUtils.prefersReducedMotion) return;
          if (pointerId !== null) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          if (event.clientX <= SWIPE_EDGE_PX) return;
          if (event.target.closest('input, textarea')) return;

          /* Interrupt an in-flight spring-back and re-claim from the rendered
             position so the gesture never snaps. */
          if (this._settleAnim) {
            const current = this.#renderedTranslateX();
            this._settleAnim.cancel();
            this._settleAnim = null;
            pointerId = event.pointerId;
            claimed = true;
            dx = current / SWIPE_DAMPING;
            originX = event.clientX - dx;
            startY = event.clientY;
            samples = [{ x: event.clientX, t: event.timeStamp }];
            this.dataset.gesture = 'dragging';
            nav.setPointerCapture(pointerId);
            return;
          }

          pointerId = event.pointerId;
          originX = event.clientX;
          startY = event.clientY;
          dx = 0;
          dy = 0;
          claimed = false;
          samples = [{ x: event.clientX, t: event.timeStamp }];
        };

        const onMove = (event) => {
          if (event.pointerId !== pointerId) return;
          dx = event.clientX - originX;
          dy = event.clientY - startY;

          if (!claimed) {
            if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > SWIPE_CLAIM_PX) {
              resetPointer();
              return;
            }
            if (Math.abs(dx) - Math.abs(dy) <= SWIPE_CLAIM_PX) return;
            claimed = true;
            this.dataset.gesture = 'dragging';
            nav.setPointerCapture(pointerId);
          }

          const now = event.timeStamp;
          samples.push({ x: event.clientX, t: now });
          samples = samples.filter((sample) => now - sample.t <= SWIPE_VELOCITY_WINDOW_MS);
          if (samples.length === 0) samples.push({ x: event.clientX, t: now });
          write();
        };

        const onUp = (event) => {
          if (event.pointerId !== pointerId) return;
          if (!claimed) {
            resetPointer();
            return;
          }

          const x = Math.max(0, dx * SWIPE_DAMPING);
          const viewportWidth = window.innerWidth || 1;
          let velocity = 0;
          if (samples.length >= 2) {
            const last = samples[samples.length - 1];
            const first = samples.find((sample) => last.t - sample.t <= SWIPE_VELOCITY_WINDOW_MS) || samples[0];
            const dt = last.t - first.t;
            if (dt > 0) velocity = (last.x - first.x) / dt;
          }

          if (dx > viewportWidth * SWIPE_CLOSE_FRACTION || velocity > SWIPE_CLOSE_VELOCITY) {
            this.#animateOutAndClose(x);
          } else {
            this.#springBack();
          }
          resetPointer();
        };

        nav.addEventListener('pointerdown', onDown);
        nav.addEventListener('pointermove', onMove);
        nav.addEventListener('pointerup', onUp);
        nav.addEventListener('pointercancel', onUp);
      }

      /**
       * Fly the drawer off-screen from its current position, then let the
       * manager close it without re-running the CSS exit.
       * @param {number} fromX - current translateX in px.
       */
      #animateOutAndClose(fromX) {
        const duration = this.#cssMs('--motion-exit');
        const viewportWidth = window.innerWidth || 1;
        const fromOpacity = this.dialog.style.opacity || '1';
        this.dataset.gesture = 'dragging';
        const anim = this.dialog.animate(
          [
            { transform: 'translateX(' + fromX + 'px)', opacity: fromOpacity },
            { transform: 'translateX(' + viewportWidth + 'px)', opacity: SWIPE_MIN_OPACITY },
          ],
          { duration: duration, easing: 'ease-out', fill: 'forwards' }
        );
        anim.finished
          .then(() => {
            this.dataset.instant = 'true';
            return window.themeUtils.surfaces.close('mobile-menu');
          })
          .then(() => {
            anim.cancel();
            delete this.dataset.instant;
            this.#clearGestureStyles();
          })
          .catch(() => {
            this.#clearGestureStyles();
          });
      }

      /** Spring the drawer back to rest; interruptible by a fresh pointerdown. */
      #springBack() {
        const duration = this.#cssMs('--motion-exit');
        const easing = this.#cssEasing('--spring-drawer');
        const fromTransform = this.dialog.style.transform || 'translateX(0)';
        const fromOpacity = this.dialog.style.opacity || '1';
        this._settleAnim = this.dialog.animate(
          [
            { transform: fromTransform, opacity: fromOpacity },
            { transform: 'translateX(0)', opacity: '1' },
          ],
          { duration: duration, easing: easing, fill: 'none' }
        );
        this._settleAnim.finished
          .then(() => {
            this._settleAnim = null;
            this.#clearGestureStyles();
          })
          .catch(() => {});
      }

      /* ── Gesture helpers ─────────────────────────────────────────── */

      /** Remove inline gesture styles + the dragging flag. */
      #clearGestureStyles() {
        this.dialog.style.transform = '';
        this.dialog.style.opacity = '';
        delete this.dataset.gesture;
      }

      /**
       * @returns {number} the drawer's current rendered translateX in px.
       */
      #renderedTranslateX() {
        const transform = getComputedStyle(this.dialog).transform;
        if (!transform || transform === 'none') return 0;
        try {
          return new DOMMatrixReadOnly(transform).m41;
        } catch (error) {
          return 0;
        }
      }

      /**
       * Read a millisecond duration token so JS never hardcodes durations.
       * @param {string} name - custom property name.
       * @returns {number} milliseconds.
       */
      #cssMs(name) {
        const raw = getComputedStyle(this.dialog).getPropertyValue(name).trim();
        const value = parseFloat(raw);
        if (Number.isNaN(value)) return 190;
        return raw.endsWith('ms') ? value : value * 1000;
      }

      /**
       * Read an easing token (linear() spring or cubic-bezier fallback).
       * @param {string} name - custom property name.
       * @returns {string} a WAAPI-compatible easing.
       */
      #cssEasing(name) {
        return getComputedStyle(this.dialog).getPropertyValue(name).trim() || 'ease-out';
      }
    }

    window.customElements.define('mobile-menu-drawer', MobileMenuDrawer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /*
   * Hover-overlay <-> slider sync.
   *
   * Visibility is CSS-driven, gated by three pieces of state:
   *
   *   - `.product-card__media:hover`                — cursor is on the image
   *   - `media-slider[data-at-origin="true"]`       — slider on its 1st slide
   *   - `media-slider:not([data-hover-suppressed])` — no arrow click yet
   *                                                   during this hover
   *
   * JS handles two things only:
   *
   *   1. **Seamless next-from-origin.** When the user clicks the
   *      next arrow while the overlay is showing, we instant-jump
   *      the slider to its 2nd slide *before* the native arrow
   *      handler runs. The jump flips `data-at-origin` to "false"
   *      synchronously, which un-matches the CSS rule and hides
   *      the overlay instantly. The slider is now on image 2
   *      (matching what the overlay was showing) and the native
   *      handler animates image 2 -> image 3. The join is invisible.
   *
   *      Prev-from-origin is NOT intercepted: the native prev
   *      handler runs alone, the slider conveyor-belts backwards
   *      to the last image, `data-at-origin` flips to "false",
   *      overlay hides instantly. (Intercepting prev would defeat
   *      the slider's infinite loop — the instant pre-jump forward
   *      would cancel out the native step backwards.)
   *
   *   2. **Hover suppression.** Once the user has clicked an arrow
   *      during a hover session, the overlay must stay hidden for
   *      the remainder of that hover — even if the slider later
   *      animates back to its origin slide (e.g. several prev
   *      clicks looping around to image 1). We set
   *      `data-hover-suppressed` on the slider on the first arrow
   *      click and clear it on pointer-leave of the card, so the
   *      next hover session starts fresh.
   *
   * Single capture-phase click delegate + bubbling pointerout
   * delegate on `document` mean cards hydrated dynamically
   * (Searchspring, colour-swap, collection grid) need no per-card
   * wiring.
   */
  (function () {
    if (window.__pmProductCardHoverSync) return;
    window.__pmProductCardHoverSync = true;

    const MQ_HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');

    /**
     * Capture-phase click handler. Runs *before* `<media-slider>`'s
     * own arrow click handler so the optional instant pre-jump
     * completes before the native step animates.
     *
     * @param {MouseEvent} event
     */
    function onArrowClick(event) {
      if (!MQ_HOVER.matches) return;
      const arrow = event.target && event.target.closest ? event.target.closest('.media-slider__arrow') : null;
      if (!arrow) return;
      const slider = arrow.closest('media-slider');
      if (!slider || typeof slider.next !== 'function') return;

      // Only product-card media has the hover overlay this sync exists for.
      // Other media-sliders (quick-add drawer, PDP gallery) must keep their
      // native single-step arrows — a pre-jump there skips a slide.
      if (!slider.classList.contains('product-card__media')) return;

      const isNext = arrow.classList.contains('media-slider__arrow--next');
      const atOrigin = slider.dataset.atOrigin === 'true';

      // Seamless next-from-origin only. Prev is left to the native
      // handler so the slider's infinite loop works (prev at slide
      // 1 should animate to the last slide).
      if (isNext && atOrigin) {
        slider.next({ instant: true });
      }

      // Any in-hover arrow click suppresses the overlay until the
      // user leaves and re-enters the card. Without this, looping
      // back to the origin slide via prev clicks would re-trigger
      // the hover preview on top of the slide the user landed on.
      slider.dataset.hoverSuppressed = 'true';
    }

    /**
     * Bubbling pointerout handler. `pointerleave` doesn't bubble,
     * so we use `pointerout` and inspect `relatedTarget` to detect
     * a true media exit (cursor moved outside the media, not just
     * between descendants).
     *
     * @param {PointerEvent} event
     */
    function onPointerOut(event) {
      const slider = event.target && event.target.closest ? event.target.closest('.product-card__media') : null;
      if (!slider) return;
      const related = event.relatedTarget;
      if (related && slider.contains(related)) return;
      if (slider.dataset.hoverSuppressed) {
        delete slider.dataset.hoverSuppressed;
      }
    }

    document.addEventListener('click', onArrowClick, true);
    document.addEventListener('pointerout', onPointerOut);
  })();

  /*
   * Hover-image lazy promotion.
   *
   * The hover preview's URL is emitted on `data-src` (no `src`) so
   * touch devices — where the CSS hover gate means it can never
   * show — never download it. On the first `pointerover` of a card
   * on a hover-capable device the URL is promoted to `src`;
   * deleting `data-src` makes the promotion once-only per image.
   *
   * A single bubbling `pointerover` delegate on `document`
   * (`pointerenter` does not bubble) covers server-rendered and
   * hydrated/injected cards alike with no per-card wiring.
   */
  (function () {
    if (window.__pmProductCardHoverImageLoad) return;
    window.__pmProductCardHoverImageLoad = true;

    const MQ_HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');

    /**
     * Promote the hover-preview image of the card under the pointer
     * from `data-srcset`/`data-src` to real attributes.
     *
     * @param {PointerEvent} event
     */
    function onPointerOver(event) {
      if (!MQ_HOVER.matches) return;
      const card = event.target && event.target.closest ? event.target.closest('[data-js="product-card"]') : null;
      if (!card) return;
      const image = card.querySelector('.product-card__hover-image[data-src]');
      if (!image) return;
      if (image.dataset.srcset) {
        image.srcset = image.dataset.srcset;
        delete image.dataset.srcset;
      }
      image.src = image.dataset.src;
      delete image.dataset.src;
    }

    document.addEventListener('pointerover', onPointerOver);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-size-guide"] && !Shopify.designMode) return;
  try {
    /**
   * Initialise a size guide toggle button.
   * @param {HTMLElement} btn - The toggle button element.
   * @returns {void}
   */
  function initialiseSizeGuideToggle(btn) {
    btn.dataset.initialised = 'true';

    btn.addEventListener('click', (e) => {
      const toggleBtn = e.currentTarget;
      const targetUnit = toggleBtn.dataset.active === 'cm' ? 'in' : 'cm';

      document.querySelectorAll('[data-js="size-unit-toggle"]').forEach((button) => {
        button.dataset.active = targetUnit;
        button.setAttribute('aria-checked', targetUnit === 'in' ? 'true' : 'false');
      });

      document.querySelectorAll('[data-unit-view]').forEach((wrapper) => {
        wrapper.dataset.unitView = targetUnit;
      });
    });
  }

  function initSizeGuide() {
    document
      .querySelectorAll('[data-js="size-unit-toggle"]:not([data-initialised="true"])')
      .forEach(initialiseSizeGuideToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuide);
  } else {
    initSizeGuide();
  }
  document.addEventListener('shopify:section:load', initSizeGuide);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yotpo-vip-desktop"] && !Shopify.designMode) return;
  try {
    /**
   * Activate the tab and tile whose dataset id matches the target, deactivating
   * the rest.
   * @param {HTMLElement} root - The `[data-js="vip-desktop"]` component root.
   * @param {string} target - The tab/tile id to activate (e.g. "1").
   * @returns {void}
   */
  function activateVipDesktopTile(root, target) {
    root.querySelectorAll('.tab').forEach((tab) => {
      tab.dataset.active = tab.dataset.tab === target ? 'true' : 'false';
    });
    root.querySelectorAll('.tile').forEach((tile) => {
      tile.dataset.active = tile.dataset.tile === target ? 'true' : 'false';
    });
  }

  /**
   * Initialise the desktop VIP tier tabs: delegated click handling for both
   * tab clicks and tile image clicks, plus keyboard (Enter/Space) activation
   * for the tabs.
   * @param {HTMLElement} root - The `[data-js="vip-desktop"]` component root.
   * @returns {void}
   */
  function initialiseVipDesktop(root) {
    root.dataset.initialised = 'true';

    root.addEventListener('click', (event) => {
      const tab = event.target.closest('.tab');
      if (tab) {
        activateVipDesktopTile(root, tab.dataset.tab);
        return;
      }

      const image = event.target.closest('.tile img:not(.tier-header)');
      if (!image) return;
      const tile = image.closest('.tile');
      if (!tile) return;
      activateVipDesktopTile(root, tile.dataset.tile);
    });

    root.addEventListener('keydown', (event) => {
      const tab = event.target.closest('.tab');
      if (!tab) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      activateVipDesktopTile(root, tab.dataset.tab);
    });
  }

  document.querySelectorAll('[data-js="vip-desktop"]:not([data-initialised="true"])').forEach(initialiseVipDesktop);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yotpo-vip-mobile"] && !Shopify.designMode) return;
  try {
    /**
   * Show the tile matching the given id and hide its tab, keeping the other
   * tabs visible.
   * @param {HTMLElement} root - The `[data-js="vip-mobile"]` (`#tiers`) component root.
   * @param {string} id - The tab/tile id to activate (e.g. "1").
   * @returns {void}
   */
  function setActiveVipMobileTile(root, id) {
    root.querySelectorAll('.tile').forEach((tile) => {
      tile.dataset.active = tile.dataset.id === id ? 'true' : 'false';
    });
    root.querySelectorAll('.tab').forEach((tab) => {
      tab.dataset.active = tab.dataset.id === id ? 'true' : 'false';
    });
  }

  /**
   * Initialise the mobile VIP tier list: delegated click and keyboard
   * (Enter/Space) activation for the tabs.
   * @param {HTMLElement} root - The `[data-js="vip-mobile"]` (`#tiers`) component root.
   * @returns {void}
   */
  function initialiseVipMobile(root) {
    root.dataset.initialised = 'true';

    root.addEventListener('click', (event) => {
      const tab = event.target.closest('.tab');
      if (!tab) return;
      setActiveVipMobileTile(root, tab.dataset.id);
    });

    root.addEventListener('keydown', (event) => {
      const tab = event.target.closest('.tab');
      if (!tab) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      setActiveVipMobileTile(root, tab.dataset.id);
    });
  }

  document.querySelectorAll('[data-js="vip-mobile"]:not([data-initialised="true"])').forEach(initialiseVipMobile);
  } catch(e) { console.error(e); }
})();

})();
